module.exports = __webpack_public_path__ + "static/img/center.443de67.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center.gif
// module id = 833
// module chunks = 1